import React from 'react';
import { Nav, Badge } from 'react-bootstrap';

const FilterTabs = ({ categories, activeTab, onTabChange, activeFilters }) => {
  const getActiveCountForCategory = (categoryName) => {
    if (!categories[categoryName]) return 0;
    
    return categories[categoryName].filter(filter => 
      activeFilters.hasOwnProperty(filter.id)
    ).length;
  };

  const getTotalActiveCount = () => {
    return Object.keys(activeFilters).length;
  };

  return (
    <Nav variant="tabs" className="mb-3" style={{ borderBottom: '2px solid #e9ecef' }}>
      <Nav.Item>
        <Nav.Link
          active={activeTab === 'all'}
          onClick={() => onTabChange('all')}
          className="d-flex align-items-center gap-2"
        >
          All Filters
          {getTotalActiveCount() > 0 && (
            <Badge bg="primary" pill>{getTotalActiveCount()}</Badge>
          )}
        </Nav.Link>
      </Nav.Item>
      
      {Object.entries(categories).map(([categoryKey, filters]) => {
        if (!filters || filters.length === 0) return null;
        
        const activeCount = getActiveCountForCategory(categoryKey);
        const categoryName = categoryKey.charAt(0).toUpperCase() + categoryKey.slice(1);
        
        return (
          <Nav.Item key={categoryKey}>
            <Nav.Link
              active={activeTab === categoryKey}
              onClick={() => onTabChange(categoryKey)}
              className="d-flex align-items-center gap-2"
            >
              {categoryName}
              <Badge bg="secondary" pill>{filters.length}</Badge>
              {activeCount > 0 && (
                <Badge bg="primary" pill>{activeCount}</Badge>
              )}
            </Nav.Link>
          </Nav.Item>
        );
      })}
    </Nav>
  );
};

export default FilterTabs;